import { hasAnyAuthToken } from '@repo/api';
import { PATH } from '@repo/constants';
import { useAppType, useUserDetailsQuery } from '@repo/lib';
import { AppType, MaintenanceType } from '@repo/types';
import {
  AppSidebar,
  AppSidebarInset,
  ImpersonationBanner,
  SidebarProvider,
  Spinner,
  Toaster,
} from '@ui/components';
import { MaintenanceProvider, VersionProvider } from '@ui/providers';
import { Navigate, useLocation } from 'react-router-dom';

export const DashboardLayout = () => {
  const appType = useAppType();
  const { search } = useLocation();
  const hasAuthToken = hasAnyAuthToken();
  const { error, isPending } = useUserDetailsQuery(hasAuthToken);
  const errorStatus = (
    error as { response?: { status?: number } } | null
  )?.response?.status;
  const isUnauthorized = errorStatus === 401;
  const isSidebarClosedByQuery =
    new URLSearchParams(search).get('sidebar') === 'closed';

  if (!hasAuthToken) {
    return (
      <Navigate
        replace
        to={PATH.AUTH_LOGIN}
      />
    );
  }

  if (isUnauthorized) {
    return (
      <Navigate
        replace
        to={PATH.AUTH_LOGIN}
      />
    );
  }

  if (isPending) {
    return (
      <div className="absolute inset-0">
        <Spinner className="size-14 text-primary" />
      </div>
    );
  }

  const content = (
    <VersionProvider>
      <ImpersonationBanner />
      <SidebarProvider defaultOpen={!isSidebarClosedByQuery}>
        <AppSidebar />
        <AppSidebarInset />
        <Toaster />
      </SidebarProvider>
    </VersionProvider>
  );

  return appType === AppType.PORTAL ? (
    <MaintenanceProvider type={MaintenanceType.PORTAL}>
      {content}
    </MaintenanceProvider>
  ) : (
    content
  );
};
